enum MatchingHeaderCategory {
  CAMPAIGN = 'campaign',
  CONSTITUENT = 'constituent',
  CONTRIBUTON = 'contribution',
}

export default MatchingHeaderCategory;
